import Main from './TaiwanIcon';

export default Main;
